import React from "react";

import Image from "next/image";

import CentralizedDataImage from "public/images/enerflo-icon-reporting-centralized-data.png";
import FiltersAnnotationsImage from "public/images/enerflo-icon-reporting-filters-annotations.png";
import ScheduledReportsImage from "public/images/enerflo-icon-reporting-scheduled-reports.png";
import ShareExportDownloadImage from "public/images/enerflo-icon-reporting-share-export-download.png";
import VisualDashboardsImage from "public/images/enerflo-icon-reporting-visual-dashboards.png";

import Heading from "../../../heading";
import HeroSection from "../../../hero-section";
import styles from "./index.module.css";

const items = [
  {
    title: "Centralized Data",
    description: "Everything in one place.",
    image: CentralizedDataImage,
  },
  {
    title: "Visual Dashboards",
    description: "Charts, graphs, tables galore.",
    image: VisualDashboardsImage,
  },
  {
    title: "Scheduled Reports",
    description: "Automated delivery, no manual effort.",
    image: ScheduledReportsImage,
  },
  {
    title: "Filters & Annotations",
    description: "Drill down, highlight insights.",
    image: FiltersAnnotationsImage,
  },
  {
    title: "Share & Export",
    description: "Multiple formats at your fingertips.",
    image: ShareExportDownloadImage,
  },
];

const title = "All Your Data. In One Place.";

const YourData = () => (
  <div className="bg-navy text-white">
    <HeroSection title={title} className="flex-col">
      <HeroSection.Content className="w-full md:w-3/4 md:text-center">
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description className="text-gray-300">
          We’ve integrated best-in-class BI technology directly into Enerflo. Now, your reporting is fully connected,
          always up-to-date, and ready to drive your next big decision. Here’s what’s included for every Enerflo Partner
          as part of your Enerflo subscription:
        </HeroSection.Description>
      </HeroSection.Content>

      <div className={styles.itemsGrid}>
        {items.map((item, index) => (
          <div key={index} className={styles.item}>
            <div>
              <figure className="h-20 w-20 lg:h-28 lg:w-28 relative mx-auto">
                <Image src={item.image} alt={`Enerflo Reporting Suite: ${item.title} Icon.`} layout="fill" />
              </figure>
              <Heading tag="h4" size="h5" className="text-primary mt-2">
                {item.title}
              </Heading>
            </div>
            <p className="mt-2 text-gray-300">{item.description}</p>
          </div>
        ))}
      </div>
    </HeroSection>
  </div>
);

export default YourData;
